import React from 'react';
import { useTranslation } from 'react-i18next';
import { UtpCardSection, UtpCardStructure } from 'common/components';
import { ST_PETERSBURG } from 'common/constants/region-codes';
import { STORAGE_ELEMENT_BLOCK, STORAGE_CDN_PATH } from '../../storage-constants';
import { AllPurchasesModal } from './components/all-purchases-modal';
import { ConvenientSolutionsModal } from './components/convenient-solutions-modal';
import { FreeStorageProjectModal } from './components/free-storage-project-modal';
import { GuaranteeModal } from './components/guarantee-modal';
import { OnlineConstructorModal } from './components/online-constructor-modal';
import { ServicesModal } from './components/services-modal';

type StorageDesignSectionProps = {
  isRuRegion: boolean;
  regionId: string;
};

export const StorageDesignSection = ({ isRuRegion, regionId }: StorageDesignSectionProps) => {
  const { t } = useTranslation();

  return (
    <UtpCardSection
      elementBlock={STORAGE_ELEMENT_BLOCK}
      elementText={t('utp-section.element-text')}
      renderModalContent={({ modal: { content: ModalContent } = {} }) =>
        ModalContent && <ModalContent regionId={regionId} />
      }
      title={t('utp-section.title') || ''}
      utpCardList={[
        {
          elementName: t('utp-section.free-project.card-title'),
          header: {
            title: t('utp-section.free-project.card-title'),
            mobileTitle: t('utp-section.free-project.card-mobile-title') || '',
          },
          description: {
            text: t('utp-section.free-project.card-description'),
            mobileText: t('utp-section.free-project.card-mobile-description') || '',
          },
          image: {
            alt: t('utp-section.free-project.card-title'),
            src: `${STORAGE_CDN_PATH}/utp/free-project.png/free-project-01.png`,
          },
          modal: { content: FreeStorageProjectModal },
        },
        ...(isRuRegion
          ? [
              {
                elementName: t('utp-section.online-constructor.card-title'),
                header: {
                  title: t('utp-section.online-constructor.card-title'),
                },
                description: {
                  text: t('utp-section.online-constructor.card-description'),
                },
                image: {
                  alt: t('utp-section.online-constructor.card-title'),
                  src: `${STORAGE_CDN_PATH}/utp/constructor.png/constructor-01.png`,
                },
                modal: { content: OnlineConstructorModal },
              },
            ]
          : []),
        {
          elementName: t('utp-section.services.card-title'),
          header: {
            title: t('utp-section.services.card-title'),
          },
          description: {
            text: t('utp-section.services.card-description'),
            mobileText: t('utp-section.services.card-mobile-description') || '',
          },
          image: {
            alt: t('utp-section.services.card-title'),
            src: `${STORAGE_CDN_PATH}/utp/services.png/services-01.png`,
          },
          modal: { content: ServicesModal },
        },
        {
          elementName: t('utp-section.guarantee.card-title'),
          header: {
            title: t('utp-section.guarantee.card-title'),
          },
          description: {
            text: t('utp-section.guarantee.card-description'),
          },
          image: {
            alt: t('utp-section.guarantee.card-title'),
            src: `${STORAGE_CDN_PATH}/utp/garanty.png/garanty-01.png`,
          },
          modal: { content: GuaranteeModal },
        },
        ...(regionId === ST_PETERSBURG
          ? [
              {
                elementName: 'Шкафы и гардеробные на заказ',
                header: {
                  title: 'Шкафы и\u00A0гардеробные на\u00A0заказ',
                },
                description: {
                  text: 'Удобные и\u00A0стильные решения под ваши размеры',
                },
                image: {
                  alt: 'Удобные и стильные решения под ваши размеры',
                  src: `${STORAGE_CDN_PATH}/utp/goods.png/goods-01.png`,
                },
                modal: {
                  content: ConvenientSolutionsModal,
                  size: 'm',
                },
              },
            ]
          : [
              {
                elementName: t('utp-section.all-purchases.card-title'),
                header: {
                  title: t('utp-section.all-purchases.card-title'),
                },
                description: {
                  text: t('utp-section.all-purchases.card-description'),
                },
                image: {
                  alt: t('utp-section.all-purchases.card-description'),
                  src: `${STORAGE_CDN_PATH}/utp/goods.png/goods-01.png`,
                },
                modal: {
                  content: AllPurchasesModal,
                  size: 'm',
                },
              },
            ]) as UtpCardStructure<{regionId: string}>[],
      ]}
    />
  );
};
